export default "__VITE_ASSET__Cc6yH4ps__"